import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;

  align-items: center;
`;

export const InfosContainer = styled.div`
  height: 88px;
  width: 100%;

  display: flex;
  align-items: center;

  column-gap: 24px;
`;
